import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { getNativeAppVersionLabel, getWebReleaseId } from 'Utils/appVersion';

// In the apps: "Version 1.2.16 (145)" from the installed app, then the web
// release id. On the web: the release id alone.
const AppVersion = () => {
  const [nativeVersion, setNativeVersion] = useState<string | null>(null);
  const releaseId = getWebReleaseId();

  useEffect(() => {
    let mounted = true;
    getNativeAppVersionLabel().then((label) => {
      if (mounted) setNativeVersion(label);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (!nativeVersion && !releaseId) return null;

  return (
    <Typography
      variant="caption"
      component="div"
      data-testid="app-version"
      sx={{
        color: '#fff',
        position: 'fixed',
        bottom: 16,
        right: 16,
        textAlign: 'right',
        // Taps go through to whatever the caption sits over.
        pointerEvents: 'none',
      }}
    >
      {nativeVersion && <div>{nativeVersion}</div>}
      {releaseId && <div>{releaseId}</div>}
    </Typography>
  );
};

export default AppVersion;
